<div class="demo-full-width margin-top" [formGroup]="group">
  <ion-item>
    <ion-checkbox [formControlName]="field.name"></ion-checkbox>
    <ion-label>{{ field.label }}</ion-label>
  </ion-item>
</div>
